var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    height: 16,
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.7142857142857142,0,0,1.7142857142857142,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75,12.493H.75a.75.75,0,0,0,0,1.5h11a.75.75,0,0,0,0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.561,1.493,12.5.432a1.537,1.537,0,0,0-2.121,0L3.671,7.139a.5.5,0,0,0-.138.267L3,10.411A.5.5,0,0,0,3.5,11a.433.433,0,0,0,.087-.008l3.005-.53a.5.5,0,0,0,.267-.139l6.707-6.707a1.5,1.5,0,0,0,0-2.121Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7a7bab8a4d3a3aeb4f901d9ea166c2c4.svg";
export { ForwardRef as ReactComponent };